import React from 'react'

const SvgComponent = (props, ref) => (
  <svg
    data-testid="clipboard-with-trend-up-icon"
    viewBox="-10 -10 120 140"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...{ ...{ width: '1em', height: '1em' }, ...props }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.10403 0H95.896C98.1625 0 100 1.57406 100 3.51562V116.484C100 118.426 98.1625 120 95.896 120H4.10403C1.83751 120 0 118.426 0 116.484V3.51562C0 1.57406 1.83751 0 4.10403 0ZM69.0717 16.9884V7.03125H30.9283V16.9884H69.0717ZM8.20807 112.969H91.7919V7.03125H77.2798V20.5041C77.2798 22.4456 75.4423 24.0197 73.1758 24.0197H26.8242C24.5577 24.0197 22.7202 22.4456 22.7202 20.5041V7.03125H8.20807V112.969ZM61.2008 51.5012H77.0021C79.2689 51.5012 81.1061 53.0753 81.1059 55.0171V68.5527C80.8911 73.2137 73.1148 73.2172 72.8978 68.5527V63.5042L50.5751 82.6264C49.0468 83.9882 46.2996 83.9882 44.7712 82.6264L32.1478 71.8128L25.8989 77.1655C21.8997 80.3312 16.3978 75.6231 20.095 72.1937L29.2459 64.355C30.849 62.9821 33.4474 62.9821 35.0499 64.355L47.6733 75.1686L67.0941 58.5325H61.2008C55.7596 58.3485 55.7555 51.6871 61.2008 51.5012Z"
      fill="currentColor"
    />
  </svg>
)

const ClipboardWithTrendUpIcon = React.forwardRef(SvgComponent)
export default ClipboardWithTrendUpIcon
